module.exports = __webpack_public_path__ + "static/img/title.9c3bd76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobel/title.png
// module id = OaZk
// module chunks = 1